import React from "react"
export function DigitLogo(props) {
  return (
    <svg viewBox="0 0 36 18" {...props}>
      <defs>
        <path id="prefix__a" d="M0 .702h8.615v12.782H0z" />
        <path id="prefix__c" d="M0 17.28h35.043V0H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 .28)">
          <mask id="prefix__b" fill="#fff">
            <use xlinkHref="#prefix__a" />
          </mask>
          <path
            d="M6.443 9.147a2.099 2.099 0 10-4.19 0 2.098 2.098 0 003.184 1.933 2.099 2.099 0 001.006-1.933zM8.615.702v12.6H6.406v-.573a3.57 3.57 0 01-2.28.754A4.13 4.13 0 01.006 9.147a4.131 4.131 0 014.118-4.364 3.64 3.64 0 012.245.728V.702h2.245z"
            fill="#000"
            mask="url(#prefix__b)"
          />
        </g>
        <mask id="prefix__d" fill="#fff">
          <use xlinkHref="#prefix__c" />
        </mask>
        <path
          fill="#000"
          mask="url(#prefix__d)"
          d="M10.879 13.582h2.246V5.246h-2.246zm10.064-4.364a1.946 1.946 0 10-3.882-.264 1.946 1.946 0 003.882.264zm2.19-3.973v8.091a3.876 3.876 0 01-1.199 2.868 3.876 3.876 0 01-2.919 1.068 3.89 3.89 0 01-3.872-2.663l2.063-.773a1.756 1.756 0 001.82 1.273 1.746 1.746 0 001.872-1.818V12.6a3.299 3.299 0 01-2.137.71 3.949 3.949 0 01-3.964-4.1 3.949 3.949 0 013.918-4.137 3.325 3.325 0 012.182.755v-.573h2.228l.008-.009zm2.247 8.337h2.245V5.246H25.38zm7.036-8.336h2.627v2.136h-2.627v3.072a.905.905 0 00.267.713c.188.188.45.283.714.26h1.646v2.137h-2.118a2.583 2.583 0 01-2.728-2.728V7.382h-1.209V6.227L31.171 3.5h1.245v1.746zM11.998 2.764h11.136V1H11.998z"
        />
        <path
          fill="#FDB913"
          mask="url(#prefix__d)"
          d="M27.634 1.873L25.934 0h-.554v3.764h.545z"
        />
      </g>
    </svg>
  )
}
